import { SingleDonation as SingleDonationForm } from "@bgea-js/form-templates";
import customConfirmationHymns from "../../../../src/content/classic-hymns/customConfirmation";
import "../../../../src/content/classic-hymns/classic-hymns.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationHymns,
  React
};